export const STEP_ORDER = ['requirements', 'documents', 'application', 'regime', 'yearly'];

export const STEP_TITLES = {
    requirements: 'Requisits',
    documents: 'Documents',
    application: 'Presentació a la Generalitat',
    regime: 'Desgravació (Llei 49/2002)',
    yearly: 'Obligacions de cada any',
};

export const CHECK_LABELS = {
    years: 'Fa més de 2 anys que la colla és inscrita al Registre d’Associacions',
    board: 'La junta vigent és inscrita al Registre',
    nif: 'El NIF de la colla és a Dades fiscals',
    openActivities: 'Les activitats són obertes a tothom, no només als socis',
    unpaidBoard: 'La junta no cobra res (només, si de cas, les despeses justificades)',
    keepsAccounts: 'La colla porta la comptabilitat: els ingressos i les despeses de cada any',
    statutes: 'Els estatuts diuen a qui van els béns de la colla si es dissol',
};

// The clause the Llei 49/2002 asks the statutes for (art. 3.6), to copy
export const DISSOLUTION_CLAUSE = 'En cas de dissolució, el patrimoni de l’associació es destinarà íntegrament a entitats beneficiàries del mecenatge segons la Llei 49/2002, de 23 de desembre, o a entitats públiques de naturalesa no fundacional que persegueixin finalitats d’interès general.';

// The four the junta confirms; the rest Aleta checks
export const CONFIRMED_CHECKS = {
    statutes: 'statutesDissolution',
    openActivities: 'openActivities',
    unpaidBoard: 'unpaidBoard',
    keepsAccounts: 'keepsAccounts',
};

export const RETURN_PATH = '/quotes/utilitat-publica';

// To sign the memòria with a digital certificate
export const SIGNING_LINKS = {
    idcat: 'https://idcat.aoc.cat',
    autofirma: 'https://firmaelectronica.gob.es/Home/Descargas.html',
    valide: 'https://valide.redsara.es/valide/',
};
